import { render, staticRenderFns } from "./Company_absences.vue?vue&type=template&id=284f4b34&scoped=true&lang=pug&"
import script from "./Company_absences.vue?vue&type=script&lang=coffee&"
export * from "./Company_absences.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f4b34",
  null
  
)

export default component.exports